import { Component, Vue } from 'vue-property-decorator'
import { getUser } from '@/utils/common'
import { getModule } from 'vuex-module-decorators'

import ConfigSolicitacaoCirurgiaStore from '@/components/Configuracoes/store/ConfigSolicitacaoCirurgiaStore'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'
import { useHospitais } from '@/composables'
import ConfiguracaoSolicitacaoCirurgiaModule from './configuracao-solicitacao-cirurgia.module'

@Component({
  ...ConfiguracaoSolicitacaoCirurgiaModule,
})
export default class ViewConfiguracaoSolicitacaoCirurgia extends Vue {
  loadSaveRules: boolean = false

  get loadingSaveRules() { return this.loadSaveRules }
  set loadingSaveRules(value: boolean) { this.loadSaveRules = value }
  get configSolicitacaoCirurgiaStore() { return getModule(ConfigSolicitacaoCirurgiaStore, this.$store) }
  get hospitalId() { return this.configSolicitacaoCirurgiaStore.hospitalId }
  set hospitalId(value: string) { this.configSolicitacaoCirurgiaStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }


  templatesValidationMap = new Map<number, boolean>()

  async saveRules() {
    if (!this.allTemplateAreValid()) {
      const index = Array.from(this.templatesValidationMap.values()).indexOf(false)
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `O Template por convênio ${index + 1} está inválido.
        Verifique e tente novamente`,
        icon: 'warning',
        color: '#C62828',
      })
      return
    }

    this.loadingSaveRules = true

    try {
      const response = await this.configSolicitacaoCirurgiaStore.saveRules()
      if (response.success) {
        this.configSolicitacaoCirurgiaStore.reset()
        EventBus.$emit('setSnackbar', { show: true, text: `Configuração salva com sucesso! ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um erro durante a requisição... ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro, tente novamente mais tarde.', icon: 'warning', color: '#C62828' })
    }

    this.loadingSaveRules = false
  }

  async getTemplateByHospitalId(hospitalId: string) {
    if (hospitalId) {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
      await this.configSolicitacaoCirurgiaStore.getHospitalTemplateBackoffice(hospitalId)
      await this.configSolicitacaoCirurgiaStore.getConvenios(hospitalId)
      EventBus.$emit('clearLoadingRequest')
    } else {
      this.configSolicitacaoCirurgiaStore.reset()
    }
  }

  async getUser() {
    const user = getUser()
    return user
  }

  stepperValidationEvent(index: number, value: boolean) {
    this.templatesValidationMap.set(index, value)
  }

  allTemplateAreValid() {
    return !Array.from(this.templatesValidationMap.values()).includes(false)
  }

  // Permissions

  get canShowSaveButton() {
    return !!this.configSolicitacaoCirurgiaStore.hospitalId
  }

  get canShowTemplates() {
    return !!this.configSolicitacaoCirurgiaStore.hospitalId
  }
}
